import React, { useState } from 'react';

function Contact() {
  const [status, setStatus] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('Thank you! Your message has been sent. Our team will get back to you shortly.');
    e.target.reset();
  };

  return (
    <div className="container" style={{ maxWidth: '800px' }}>
      <div className="card">
        <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Contact Us</h2>
        <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
          Have questions about bulk orders, catering, or just want to say hi? Don't hesitate to reach out to us.
        </p>
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <input type="text" placeholder="Full Name" required />
          <input type="email" placeholder="Email Address" required />
          <input type="text" placeholder="Subject (e.g., Catering Order)" required />
          <textarea rows="6" placeholder="Write your message here..." required></textarea>
          <button type="submit" className="btn" style={{ width: '100%' }}>Send Message</button>
        </form>

        {status && <p style={{ marginTop: '1rem', color: 'green', textAlign: 'center', fontWeight: 'bold' }}>{status}</p>}
      </div>
    </div>
  );
}

export default Contact;